// The top bar every New design page has (x-ui.app-topbar), on the marketing layout (the homepage, /business, /api,
// /genre-charts, /radar/early-finds, /contact, legal pages). The marketing bundle has no Alpine; this entry starts it
// for the bar's section menus, account menu and phone menu sheet only. Loaded after ui-marketing.js.
import Alpine from 'alpinejs';
import { uiDropdown, uiDialog } from './alpine/ui-controls';
import { uiTopbar } from './alpine/ui-nav';

// Signed in on a page inside the app shell (Radar early finds), the layout loads Livewire for the search
// (html[data-livewire]), which starts its own Alpine: register on alpine:init instead of starting a second one.
const register = (A) => Object.entries({ uiDropdown, uiDialog, uiTopbar }).forEach(([name, fn]) => A.data(name, fn));
if (document.documentElement.hasAttribute('data-livewire')) {
    document.addEventListener('alpine:init', () => register(window.Alpine));
} else {
    window.Alpine = Alpine;
    register(Alpine);
    Alpine.start();
}
